import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const languageCourseDisplayDefaultVariants = {}
const languageCourseDisplayCompoundVariants = []

const languageCourseDisplaySlotNames = [
  [
    "root",
    "language-course-display__root"
  ],
  [
    "title",
    "language-course-display__title"
  ],
  [
    "label",
    "language-course-display__label"
  ],
  [
    "info",
    "language-course-display__info"
  ]
]
const languageCourseDisplaySlotFns = /* @__PURE__ */ languageCourseDisplaySlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, languageCourseDisplayDefaultVariants, getSlotCompoundVariant(languageCourseDisplayCompoundVariants, slotName))])

const languageCourseDisplayFn = memo((props = {}) => {
  return Object.fromEntries(languageCourseDisplaySlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const languageCourseDisplayVariantKeys = []
const getVariantProps = (variants) => ({ ...languageCourseDisplayDefaultVariants, ...compact(variants) })

export const languageCourseDisplay = /* @__PURE__ */ Object.assign(languageCourseDisplayFn, {
  __recipe__: false,
  __name__: 'languageCourseDisplay',
  raw: (props) => props,
  variantKeys: languageCourseDisplayVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, languageCourseDisplayVariantKeys)
  },
  getVariantProps
})